import logo from '@/assets/imgs/LogoBLUE.png';
import { Link } from 'react-router-dom';

export function ResetPasswordCodePage() {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 font-cairo px-3">
            <div className="w-full max-w-lg p-6 space-y-4 bg-white shadow-[0px_8px_13px_-3px_#00000012] rounded-2xl border border-[#F3E6FF]">
                <Link to="/" className="max-w-[200px] max-h-[200px] mx-auto">
                    <img src={logo} alt="logo" className="mx-auto w-full h-full" />
                </Link>
                <div className="flex flex-col gap-3 items-center justify-center">
                    <p className="text-center bg-[#DAF8E6] py-2 text-[#1A8245] w-fit px-3">تم ارسال الكود بنجاح</p>
                    <p className="text-[18px]">برجاء مراجعه الايميل الخاص</p>
                    <Link to="/login" className='underline text-gray-500 text-sm'>العوده الي صفحه تسجيل الدخول</Link>
                </div>
            </div>
        </div>
    );
}
